import { RULE_TYPES_PRODUCT_MIN_PRICE_AMOUNT } from '../constants';
import calculateMinPrice from '../calculate-min-price';

const DUPLICATE_RULE_MESSAGE = 'found more than one rule for the same type, please check your rules';

/**
 * Line extended amount: `quantity * unitPrice`, then pricing rules (e.g. minimum line amount).
 *
 * @param {object} params
 * @param {number} params.quantity
 * @param {number} params.unitPrice
 * @param {Array<{ type: string, minPriceAmount?: number }>} [params.rules=[]] - Applied in order. Duplicate `type` values throw.
 * @returns {number} Unrounded extended price after rules (caller may round).
 * @throws {Error} If more than one rule shares the same `type`.
 */
export default function calculateExtendedPrice({ quantity, unitPrice, rules = [] }) {
  const ruleTypeCounts = rules.reduce((acc, rule) => {
    const type = rule.type;
    acc[type] = (acc[type] || 0) + 1;
    return acc;
  }, {});

  const hasDuplicateRules = Object.values(ruleTypeCounts).some(count => count > 1);
  if (hasDuplicateRules) {
    throw new Error(DUPLICATE_RULE_MESSAGE);
  }

  let extendedPrice = quantity * unitPrice;

  rules.forEach(rule => {
    switch (rule.type) {
      case RULE_TYPES_PRODUCT_MIN_PRICE_AMOUNT:
        extendedPrice = calculateMinPrice(extendedPrice, rule);
        break;
      default:
        break;
    }
  });

  return extendedPrice;
}
